import React from "react";
import assets from "../../../../assets/assets";
import axios from './../../../../axios'
import { toast } from "react-toastify";

function UnattemptedQsPopup({
    setUnAnsweredPopup,
    unAttemptedTitles,
    setConfirmPopupOpen,
    questionsAnswer,
    setAllQuestion,
    type,
    state,
    setIsNotAllQuestionAnswered,
    allQuestion,
    userId
}) {

    const handleSubmit = async (assessmentId, assessmentType) => {

        try {
            if (type == "SA") {
                let notAnswer = questionsAnswer.filter(
                    (answer) => answer.answer.key == " "
                );
                if (notAnswer.length > 0) {
                    setIsNotAllQuestionAnswered(true);
                    return;
                }

                let qustionAnswer = [];
                let b4sQuestionAnswer = [];
                questionsAnswer.map((answer) => {
                    if (answer.questionSource == 'b4s') {
                        delete answer.questionSource;
                        b4sQuestionAnswer.push(answer)
                    } else if (answer.questionSource == 'question') {
                        delete answer.questionSource;
                        qustionAnswer.push(answer);
                    }
                })
                if (type == "SA") {
                    let selfAssessmentBody = {
                        student_id: userId,
                        submitted_on: new Date(),
                        questionanswers: qustionAnswer,
                        b4squestionanswers: b4sQuestionAnswer,
                    };
                    let res = await axios.post(`/${assessmentType}/${assessmentId}/studentResponse/create`, selfAssessmentBody);
                    res && setAllQuestion({ ...allQuestion, sucessful: true });

                } else {
                    let selfAssessmentBody = {
                        student_id: userId,
                        submitted_on: new Date(),
                        answers: questionsAnswer,
                    };
                    let res = await axios.post(`/${assessmentType}/${assessmentId}/studentResponse/create`, selfAssessmentBody);
                    res && setAllQuestion({ ...allQuestion, sucessful: true });
                }

            } else {

                let selfAssessmentBody = {
                    student_id: userId,
                    submitted_on: new Date(),
                    answers: questionsAnswer,
                };
                let res = await axios.post(`/${assessmentType}/${assessmentId}/studentResponse/create`, selfAssessmentBody);
                res && setAllQuestion({ ...allQuestion, sucessful: true });
            }
        } catch (error) {
            toast.error(error?.response?.data?.message ?? "Something went wrong");
            console.log(error);
        } finally {
            setUnAnsweredPopup(false);
            setConfirmPopupOpen(false);
        }
    };

    return (
        <div className="ContainerSubmitedSucess ">
            <div className="SubContainerSubmitedSucess">
                <div
                    onClick={() => {
                        setUnAnsweredPopup(false);
                        setConfirmPopupOpen(false);
                    }}
                    style={{ cursor: "pointer" }}
                    className="d-flex align-items-center"
                >
                    <img src={assets.CrossIcon} className="w-8 absolute right-2" alt="icon" />
                </div>
                <div className="">
                    <h3>Unattempted Questions</h3>
                    <div className="text-lg ml-2">
                        {unAttemptedTitles.map((q) => {
                            return (
                                <div className="flex gap-2">{q}</div>
                            )
                        })}
                    </div>

                </div>

                <div className="d-flex justify-content-around align-items-center mt-3 widthOfContainer">

                    <button
                        className="okayBtnsucessBack"
                        onClick={() => {
                            setUnAnsweredPopup(false);
                            setConfirmPopupOpen(false);
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="okayBtnsucessBack"
                        onClick={() => {
                            let assId =
                                type == "SA"
                                    ? state.selfAssessmentId
                                    : state.homeworkId;
                            let assType = type == "SA" ? "selfAssess" : "homework";
                            handleSubmit(assId, assType);
                        }}
                    >
                        Continue to Submit
                    </button>
                </div>
            </div>
        </div>
    )
}

export default UnattemptedQsPopup;
